module.exports = __webpack_public_path__ + "static/media/imagePagePlaceholderWelcome.accd0d71.svg";